import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './AppRouter';
// import './index.css';
import * as serviceWorker from './serviceWorker';
import 'jquery/dist/jquery';
import 'bootstrap/dist/js/bootstrap';
import './styles/load-styles.scss';


ReactDOM.render(<BrowserRouter> <AppRouter /> </BrowserRouter>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

